export const OPERATORS_BY_TYPE = {
    string: ['==', '!=', '=in=', '=out='],
    uuid: ['==', '!=', '=in=', '=out='],
    enum: ['==', '!=', '=in=', '=out='],
    boolean: ['==', '!='],
    integer: ['==', '!=', '=lt=', '=le=', '=gt=', '=ge=', '=in=', '=out='],
    datetime: ['==', '!=', '=lt=', '=le=', '=gt=', '=ge='],
};
/** Os operadores que o campo aceita, já com a restrição da política. */
export const operatorsOf = (field) => field.operators ?? OPERATORS_BY_TYPE[field.type];
/**
 * Declara uma política, conferindo na hora o que não depende da entrada:
 * campos de ordenação e operadores que fazem sentido para o tipo.
 */
export function definePolicy(policy) {
    const fields = Object.entries(policy.fields);
    for (const [name, field] of fields) {
        const invalid = (field.operators ?? []).filter((operator) => !OPERATORS_BY_TYPE[field.type].includes(operator));
        if (invalid.length > 0) {
            throw new Error(`Política: ${name} não comporta ${invalid.join(' ')}`);
        }
        if (field.type === 'enum' && (field.values ?? []).length === 0) {
            throw new Error(`Política: ${name} é enum e não lista os valores`);
        }
    }
    for (const { field } of policy.defaultSort) {
        if (policy.fields[field]?.sortable !== true) {
            throw new Error(`Política: ordenação padrão por ${field}, que não é ordenável`);
        }
    }
    return policy;
}
//# sourceMappingURL=policy.js.map